import React from 'react'


export const Header = () => {
    return (
        <header>
            <h1> New albums & singles</h1>
        </header >
    )
}

